import React from 'react'
import HeaderDicas from '../components/header-dicas';
import SideBar from '../components/sidebar';
import './bootstrap.css'
import '../components/layout.css'
import Footer from '../components/footer';
import Helmet from 'react-helmet'

const Termos = () => {
    return (
       <div>
           <script src="https://code.jquery.com/jquery-3.3.1.slim.min.js" integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo" crossorigin="anonymous"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js" integrity="sha384-UO2eT0CpHqdSJQ6hJty5KVphtPhzWj9WO1clHTMGa3JDZwrnQq4sF86dIHNDz0W1" crossorigin="anonymous"></script>
            <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js" integrity="sha384-JjSmVgyd0p3pXB1rRibZUAYoIIy6OrQ6VrjIEaFf/nJGzIxFDsf4x0xIM+B07jRM" crossorigin="anonymous"></script>
           <link href="https://fonts.googleapis.com/css?family=Open+Sans&display=swap" rel="stylesheet"></link>
           <Helmet title="Termos de Uso - DevPleno" />
           <div>
               <div class = 'image-politica'>
                    <HeaderDicas/>

                    <div class = 'container text-center texto-inicial'>
                        <h2 class = 'h1 font-sobre-viva font-weight-bold text-white'>
                            TERMOS DE USO
                        </h2>
                    </div>

                </div>
            </div>
            <div style = {{fontFamily: 'Open Sans', fontSize: '0.9375rem'}} class = 'container'>
                <div class = 'row'>

                    <div class = 'col-xl-9 col-12'>
                        <div class = 'text-secondary container fonte-p'>
                            <p class = 'pt-5 '>Estes termos de serviço regulam o uso deste site. Ao acessá-lo você concorda com estes termos. Por favor, consulte regularmente os nossos termos de serviço.
                            </p>
                            <p>
                            O website $devPleno (gerenciado e mantido por We Dev Ideas – Eirelli – 
                            ME) é um serviço interativo oferecido em por meio de página 
                            eletrônica na internet que oferece informações sobre negócios, 
                            cultura, etc, e serviços relacionados a desenvolvedores a partir da 
                            integração de diversas fontes de informação. O acesso ao $devPleno 
                            representa a aceitação expressa e irrestrita dos termos de uso abaixo 
                            descritos. Se você não concorda com os termos, por favor, não acesse 
                            nem utilize este website.
                            O visitante poderá usar este site apenas para finalidades lícitas. 
                            Este espaço não poderá ser utilizado para para publicar, enviar, 
                            distribuir ou divulgar conteúdos ou informação de caráter difamatório, 
                            obsceno ou ilícito, inclusive informações de propriedade exclusiva 
                            pertencentes a outras pessoas ou empresas, bem como marcas 
                            registradas ou informações protegidas por direitos autorais, sem a 
                            expressa autorização do detentor desses direitos. Ainda, o visitante 
                            não poderá usar o site $devPleno para obter ou divulgar informações 
                            pessoais, inclusive endereços na Internet, sobre os usuários do site.
                            </p>

                            <p>
                            O $devPleno empenha-se em 
                            manter a qualidade, atualidade e autenticidade das informações do 
                            site, mas seus criadores e colaboradores não se responsabilizam por 
                            eventuais falhas nos serviços ou inexatidão das informações 
                            oferecidas. O usuário não deve ter como pressuposto que tais serviços 
                            e informações são isentos de erros ou serão adequados aos seus 
                            objetivos particulares. Os criadores e colaboradores tampouco assumem 
                            o compromisso de atualizar as informações, e reservam-se o direito de 
                            alterar as condições de uso ou preços dos serviços e produtos 
                            oferecidos no site a qualquer momento.
                            </p>

                            <p>
                            O acesso ao site $devPleno é 
                            gratuito. O $devPleno poderá criar áreas de acesso exclusivo aos seus 
                            clientes ou para terceiros especialmente autorizados.
                            </p>

                            <p>Os criadores e 
                            colaboradores do $devPleno poderão a seu exclusivo critério e em 
                            qualquer tempo, modificar ou desativar o site, bem como limitar, 
                            cancelar ou suspender seu uso ou o acesso. Também estes Termos de 
                            Uso poderão ser alterados a qualquer tempo. Visite regularmente 
                            esta página e consulte os Termos então vigentes. Algumas disposições 
                            destes Termos podem ser substituídas por termos ou avisos legais 
                            expressos localizados em determinadas páginas deste site.</p>
                            <p class = ' text-dark'>Erros e falhas</p>

                            <p>Os documentos, 
                            informações, imagens e gráficos publicados neste site podem conter 
                            imprecisões técnicas ou erros tipográficos. Em nenhuma hipótese o 
                            $devPleno e/ou seus respectivos fornecedores serão responsáveis por 
                            qualquer dano direto ou indireto decorrente da impossibilidade de 
                            uso, perda de dados ou lucros, resultante do acesso e desempenho do 
                            site, dos serviços oferecidos ou de informações disponíveis neste 
                            site. O acesso aos serviços, materiais, informações e facilidades 
                            contidas neste website não garante a sua qualidade.
                            </p>

                            <p class = ' text-dark'>Limitação da responsabilidade</p>

                            <p>Os materiais são 
                            fornecidos neste website sem nenhuma garantia explícita ou implícita 
                            de comercialização ou adequação a qualquer objetivo específico. Em 
                            nenhum caso o $devPleno ou os seus colaboradores serão 
                            responsabilizados por quaisquer danos, incluindo lucros cessantes, 
                            interrupção de negócio, ou perda de informação que resultem do uso ou 
                            da incapacidade de usar os materiais. O $devPleno não garante a 
                            precisão ou integridade das informações, textos, gráficos, links e 
                            outros itens dos materiais.
                            O$devPleno não se responsabiliza pelo conteúdo dos artigos e 
                            informações aqui publicadas, uma vez que os textos são de autoria de 
                            terceiros e não traduzem, necessariamente, a opinião do website.
                            O $devPleno tampouco é responsável pela violação de direitos autorais 
                            decorrente de informações, documentos e materiais publicados neste 
                            website, comprometendo-se a retirá-los do ar assim que notificado da 
                            infração.
                            </p>

                            <p class = ' text-dark'>Direitos autorais e propriedade intelectual</p>

                            <p>Os documentos, conteúdos e 
                            criações contidos neste website pertencem aos seus criadores e 
                            colaboradores. A autoria dos conteúdo, material e imagens exibidos no 
                            $devPleno é protegida por leis nacionais e internacionais. Não podem 
                            ser copiados, reproduzidos, modificados, publicados, atualizados, 
                            postados, transmitidos ou distribuídos de qualquer maneira sem 
                            autorização prévia e por escrito do $devPleno.
                            As imagens contidas neste website são aqui incorporadas apenas para 
                            fins de visualização, e, salvo autorização expressa por escrito, não 
                            podem ser gravadas ou baixadas via download. A reprodução ou 
                            armazenamento de materiais recuperados a partir deste serviço 
                            sujeitará os infratores às penas da lei.
                            O nome do site $devPleno seu logotipo, o nome de domínio para acesso 
                            na Internet, bem como todos os elementos característicos da 
                            tecnologia desenvolvida e aqui apresentada, sob a forma da 
                            articulação de bases de dados, constituem marcas registradas e 
                            propriedades intelectuais privadas e todos os direitos decorrentes 
                            de seu registro são assegurados por lei. Alguns direitos de uso 
                            podem ser cedidos por $devPleno em contrato ou licença especial, 
                            que pode ser cancelada a qualquer momento se não cumpridos os seus 
                            termos. As marcas registradas do $devPleno só podem ser usadas 
                            publicamente com autorização expressa. O uso destas marcas 
                            registradas em publicidade e promoção de produtos deve ser 
                            adequadamente informado.
                            </p>

                            <p class = ' text-dark'>Reclamações sobre 
                            violação de direitos autorais
                            </p>

                            <p>
                            O $devPleno respeita a 
                            propriedade intelectual de outras pessoas ou empresas e solicitamos 
                            aos nossos membros que façam o mesmo. Toda e qualquer violação de 
                            direitos autorais deverá ser notificada ao $devPleno e acompanhada 
                            dos documentos e informações que confirmam a autoria. A notificação 
                            poderá ser enviada pelos e-mails constantes do site ou via postal 
                            para o endereço do site.
                            </p>

                            <p class = ' text-dark'>Leis aplicáveis</p>

                            <p>
                            Este site é controlado e 
                            operado pela We Dev Ideas – Eirelli – ME a partir de seu escritório no 
                            endereço Rua Maria das Dores, 59/1 – Explanada, Pouso Alegre, MG e 
                            não garante que o conteúdo ou materiais estejam disponíveis para uso 
                            em outras localidades. Seu acesso é proibido em territórios onde o 
                            conteúdo seja considerado ilegal. Aqueles que optarem por acessar 
                            este site a partir de outras localidades o farão por iniciativa 
                            própria e serão responsáveis pelo cumprimento das leis locais 
                            aplicáveis. Os materiais não deverão ser usados ou exportados em 
                            descumprimento das leis brasileiras sobre exportação. Qualquer 
                            pendência com relação aos materiais será dirimida pelas leis 
                            brasileiras. O acesso ao $devPleno representa a aceitação expressa e 
                            irrestrita dos termos de uso acima descritos.
                            </p>

                        </div>
                    </div> 

                    <div class = 'col-xl-3 col-12'>
                        <SideBar/>    
                    </div> 
                      
                </div>
            </div> 
            <Footer/>
       </div>
    )
}
export default Termos